import {
    UNIT_STATE_REACTIVE_UPDATE,
} from 'state/actions/available_units'

import {
    UNIT_PARTICIPANTS_REQUEST,
    UNIT_PARTICIPANTS_SUCCESS,
    UNIT_PARTICIPANTS_ERROR,
} from 'state/actions/unit_participants'


const initialState = {
    loading: false,
    loaded: false,
    participants: [],
    unitServerId: null,
    peripheryId: null,
    error: false,
}


export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case UNIT_PARTICIPANTS_REQUEST: {
        return {
            ...state,
            loaded: false,
            loading: true,
            participants: [],
            error: false,
        }
    }
    case UNIT_PARTICIPANTS_SUCCESS: {
        const { participants, unitServerId, peripheryId } = action.payload
        return {
            ...state,
            loading: false,
            loaded: true,
            participants,
            unitServerId,
            peripheryId,
        }
    }
    case UNIT_PARTICIPANTS_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: true,
            participants: [],
            error: true,
        }
    }
    case UNIT_STATE_REACTIVE_UPDATE: {
        const { server_id, periphery } = action.payload.unit
        const participants = action.payload.members

        if (state.unitServerId === server_id && state.peripheryId === periphery.id) {
            return { ...state, participants }
        }
        return state
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/unit_participants.js